var map = {
	"./img.svg": "bc4b",
	"./mp3.svg": "e416",
	"./mp4.svg": "6e5f",
	"./null.svg": "d9bc",
	"./pdf.svg": "9848",
	"./ppt.svg": "3df8",
	"./rar.svg": "b250",
	"./txt.svg": "3c07",
	"./word.svg": "111e",
	"./xlsx.svg": "9dd3",
	"./zip.svg": "fc39"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5656";